import React from 'react';

export default ({field,tooltip,label}) => {
	return <input type="hidden" name={field.name} value={field.value || ''} id={field.key} />
};

